import React, { useState } from 'react';
import './Solucoes.css';
import iconCaptacao from '../assets/icons/captacao.png';
import iconGestao from '../assets/icons/gestao.png';
import iconFaturamento from '../assets/icons/faturamento.png';
import iconFaturas from '../assets/icons/faturas.png';
import iconDocumentos from '../assets/icons/documentos.png';
import iconPagamentos from '../assets/icons/pagamentos.png';

const cardsData = [
  {
    id: 1,
    title: 'Captação de Clientes',
    icon: iconCaptacao,
    short: 'Está com dificuldades em capturar mais clientes e melhor? Com a Lampo o cliente insere os dados e recebe uma proposta em segundos​​​​',
    expanded: [
      { label: 'Setup inteligente:', text: 'configure distribuidoras e regras de viabilidade sem planilhas ou cálculos manuais' },
      { label: 'Proposta automática:', text: 'gere ofertas personalizadas em tempo real, com experiência fluida para o cliente' },
      { label: 'Integração total:', text: 'conecte com CRMs e ERPs para monitorar e otimizar cada etapa da jornada comercial' }
    ]
  },
  {
    id: 2,
    title: 'Gestão de Energia',
    icon: iconGestao,
    short: 'Sofrendo com inúmeras planilhas? Visualize tudo que faz sentido em um só lugar: análises, recomendações e alertas de inconsistências, com clareza e confiabilidade',
    expanded: [
      { label: 'Visão operacional:', text: 'acesso rápido a indicadores-chave, relatórios completos e histórico de desempenho' },
      { label: 'Sugestões inteligentes:', text: 'identifique oportunidades de economia e performance com base nos dados reais' },
      { label: 'Validação de dados:', text: 'múltiplos níveis de verificação para detectar erros e garantir segurança nas medições' }
    ]
  },
  {
    id: 3,
    title: 'Faturamento Automatizado',
    icon: iconFaturamento,
    short: 'Precisando processar e organizar os dados, e disponibilizar faturas para os seus clientes? Visualização clara, relatórios detalhados e dados prontos para análise ou envio',
    expanded: [
      { label: 'Dashboard completo:', text: 'visualize histórico, valores, consumo e relatórios com poucos cliques' },
      { label: 'Integração e faturas:', text: 'automatize a emissão de faturas e conecte-se aos sistemas que você já utiliza' },
      { label: 'Experiência do cliente:', text: 'disponibilize informações via portal ou app, reduzindo dúvidas e aumentando a confiança' }
    ]
  },
  {
    id: 4,
    title: 'Gestão de Faturas',
    icon: iconFaturas,
    short: 'Difícil de se encontrar e organizar no meio de milhares de faturas? Centralize faturas e documentos com organização e controle. Visualize, filtre e acesse em poucos cliques',
    expanded: [
      { label: 'Organização automática:', text: 'faturas agrupadas por cliente, período ou status, tudo em um só lugar' },
      { label: 'Busca inteligente:', text: 'encontre faturas com filtros avançados por CNPJ, mês ou status de pagamento' },
      { label: 'Envio facilitado:', text: 'disponibilize faturas por portal, e-mail ou integrações, com agilidade e segurança' }
    ]
  },
  {
    id: 5,
    title: 'Documentos',
    icon: iconDocumentos,
    short: 'Diversas ferramentas de organização e assinaturas? Tenha todos os documentos em um só lugar: organize, acesse e compartilhe arquivos com praticidade e segurança',
    expanded: [
      { label: 'Centralização:', text: 'mantenha todos os documentos operacionais e regulatórios organizados em um só ambiente' },
      { label: 'Integrações:', text: 'Conexão com ferramentas de assinatura digital' },
      { label: 'Compartilhamento seguro:', text: 'permita acesso a usuários internos ou clientes com controle de permissões' }
    ]
  },
  {
    id: 6,
    title: 'Pagamentos',
    icon: iconPagamentos,
    short: 'Perdido dentre tantos pagamentos? Acompanhe o status dos pagamentos, gere boletos e receba de diversas formas e melhore sua retenção de clientes',
    expanded: [
        { label: 'Controle financeiro:', text: 'monitore pagamentos recebidos, em aberto e atrasados em tempo real' },
        { label: 'Emissão de cobrança:', text: 'gere boletos, links de pagamento ou PIX diretamente pela plataforma' },
        { label: 'Experiência do cliente:', text: 'ofereça canais simples e intuitivos para garantir o recebimento no prazo' }
    ]
  }
];

function Solucoes() {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (id) => {
    setExpandedCard(prev => (prev === id ? null : id));
  };

  return (
    <section className="solucoes-section" id="solucoes">
      <div className="dots-animation">
        <span></span><span></span><span></span>
      </div>
      <div className="solucoes-container">
        <h2>Soluções</h2>
        <p>Automatize a jornada completa do consumidor de energia com tecnologia</p>

        <div className="cards">
          {cardsData.map(card => (
            <div
              key={card.id}
              className={`card ${expandedCard === card.id ? 'expanded' : ''}`}
              onClick={() => toggleCard(card.id)}
            >
              <div className="icon-wrapper">
                <img src={card.icon} alt={card.title} className="card-icon" />
              </div>
              <h3>{card.title}</h3>
              <p>{card.short}</p>
              {expandedCard === card.id && Array.isArray(card.expanded) && (
                <div className="expanded-content">
                  <ul className="card-info">
                    {card.expanded.map((item, idx) => (
                      <li key={idx}>
                        <strong>{item.label}</strong> {item.text}
                      </li>
                    ))}
                  </ul>
                  <p className="cta-mini">
                    Interessado? <a href="#contato">Entre em contato</a>
                  </p>
                </div>
              )}

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Solucoes;
